var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2808_83783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.435 0.565049C18.6705 -0.199326 17.4273 -0.186553 16.6788 0.593408L12.5817 4.86282L2.58324 1.55396L0.484375 3.65286L8.81844 8.78431L4.60141 13.1786L1.89707 12.7346L0 14.6317L3.97578 16.0242L5.36832 20L7.26539 18.1029L6.82141 15.3986L11.2157 11.1816L16.3471 19.5156L18.4461 17.4167L15.1372 7.41825L19.4066 3.32118C20.1866 2.57267 20.1993 1.32946 19.435 0.565049Z",
    fill: "#8E9191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2808_83783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.382053df683329164a7bd89f2214a06e.svg";
export { ForwardRef as ReactComponent };